import React, { useState } from "react";
import { Table, Input, Button } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import "../components/premium.css";

const createSection = (title, columnsConfig, rows = 5) => ({
  title,
  columnsConfig,
  data: Array.from({ length: rows }, (_, i) => ({
    key: i + 1,
  })),
});

const PerformanceReview = () => {
  const [sections, setSections] = useState([
    createSection("Professional Excellence", [
      "Key Result Area",
      "Key Performance Indicators",
      "Weightage",
      "Self %",
      "Self Score",
      "RO %",
      "RO Score",
    ]),

    createSection("Personal Excellence", [
      "Personal Attributes",
      "Key Indicators",
      "Weightage",
      "Self %",
      "Self Score",
      "RO %",
      "RO Score",
    ]),

    createSection("Special Initiatives, Achievements, Contributions if any", [
      "By Self",
      "RO's Comment",
      "HOD's Comment",
    ]),

    createSection("Comments on the Role", [
      "By Self",
      "RO's Comment",
      "HOD's Comment",
    ]),

    createSection("Strengths & Areas for Improvement", [
      "Strengths",
      "Area for Improvement",
    ]),

    createSection("For RO’s Use Only", [
      "Questions / Parameters",
      "Yes / No",
      "If Yes – Details",
    ]),

    createSection("For HRD’s Use Only", [
      "Overall Parameters",
      "Available Points",
      "Points Scored",
      "RO's Comment",
    ]),

    createSection(
      "Appraisee’s Strengths and Areas for Improvement perceived by the Head of the Department",
      ["Strengths", "Area for Improvement"]
    ),

    createSection("Personal Goals", [
      "Goal Achieved During Last Year",
      "Goal Set for Current Year",
    ]),

    createSection("Personal Updates", [
      "Last Year",
      "Yes/No",
      "Details",
      "Current Year",
      "Yes/No",
      "Details",
    ]),

    createSection("Professional Goals Achieved for Last Year", [
      "By Self",
      "RO's Comment",
      "HOD's Comment",
    ]),

    createSection("Professional Goals Achieved for the Forthcoming Year", [
      "By Self",
      "RO's Comment",
      "HOD's Comment",
    ]),

    createSection("Training Requirements", [
      "By Self",
      "RO's Comment",
      "HOD's Comment",
    ]),

    createSection("Any Other General Comments, Observations, Suggestions etc.", [
      "Self",
      "RO",
      "HOD",
    ]),
  ]);

  // ✅ Add row handler (correct way)
  const handleAddRow = (sectionIndex) => {
    const updated = [...sections];
    const current = updated[sectionIndex];

    current.data.push({
      key: current.data.length + 1,
    });

    setSections(updated);
  };

  return (
    <div className="premium-wrapper">
      <h3 className="page-title">Performance Review</h3>

      {sections.map((section, index) => {
        const columns = [
          {
            title: "#",
            dataIndex: "key",
            width: 50,
          },
          ...section.columnsConfig.map((col) => ({
            title: col,
            render: () => <Input />,
          })),
          {
            title: (
              <Button
                icon={<PlusOutlined />}
                size="small"
                onClick={() => handleAddRow(index)}
              />
            ),
            width: 60,
          },
        ];

        return (
          <div key={index} className="premium-card mt-4">
            <h5 className="section-title">{section.title}</h5>

            <Table
              columns={columns}
              dataSource={section.data}
              pagination={false}
              bordered
            />
          </div>
        );
      })}
    </div>
  );
};

export default PerformanceReview;